import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { PageSection } from '../../../Layout';
import ids from '../../QestIds';
import { MeasurementsSection, ResultsSection } from '../Sections';
import { AashtoDryMassesSection, AashtoPreparationSection } from './Sections';

const qestIds = [ids.moistureContent.AASHTO_T_265.rev2015];

const AashtoMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <PageSection heading="Preparation">
      <AashtoPreparationSection />
    </PageSection>

    <PageSection heading="Measurements">
      <MeasurementsSection />
    </PageSection>

    <PageSection>
      <WorksheetTestedBySection />
    </PageSection>

    <PageSection heading="Dry Mass">
      <AashtoDryMassesSection />
    </PageSection>

    <WorksheetResultsSection heading="Results">
      <ResultsSection />
    </WorksheetResultsSection>

    <PageSection heading="Images and Remarks">
      <WorksheetImagesAndRemarksSection />
    </PageSection>
  </>
);

AashtoMoistureContentWorksheet.qestIds = qestIds;

export default AashtoMoistureContentWorksheet;
export { AashtoMoistureContentWorksheet };
